import {
  getHardwarePreferredSupplierFilterKeyFromState,
  getPrimaryPreferredSupplierFilterKeyFromState,
} from 'pages/ordering/hooks/supplierPreferenceConfig'
import { RootState } from 'types/state'
import { FeatureChecker } from 'util/featureFlags'

export const SUPPLIER_PREFERENCE_FEATURE_FLAG = 'supplier_preference_settings'

export const PREFERRED_SUPPLIER_REDUX_PATHS = ['orgs.supplierPreferences', 'orgs.sellerIntegrations'] as const

export type PreferredSupplierMatchSource = 'hardware' | 'primary'

export type PreferredSupplierCheckOptions = {
  supplierName: string
  matchSource?: PreferredSupplierMatchSource
}

export function getPreferredSupplierFilterKeyForMatch(
  state: RootState,
  matchSource: PreferredSupplierMatchSource = 'hardware'
): string | null {
  return matchSource === 'primary'
    ? getPrimaryPreferredSupplierFilterKeyFromState(state)
    : getHardwarePreferredSupplierFilterKeyFromState(state)
}

export function isSupplierPreferenceFeatureEnabled(isFeatureEnabled: FeatureChecker): boolean {
  return isFeatureEnabled(SUPPLIER_PREFERENCE_FEATURE_FLAG, 'on') === true
}

export function isPreferredSupplierMatch(
  state: RootState,
  options: PreferredSupplierCheckOptions,
  isFeatureEnabled: FeatureChecker
): boolean {
  if (!isSupplierPreferenceFeatureEnabled(isFeatureEnabled)) {
    return false
  }

  const matchSource = options.matchSource ?? 'hardware'
  return getPreferredSupplierFilterKeyForMatch(state, matchSource) === options.supplierName
}
